<template>
  <div class="py-12">
    <v-avatar size="128" @click="triggerFile()" v-if="!loading"
      ><v-img :src="$root.auth.profile.logo" width="100%" position="center center"></v-img
    ></v-avatar>
    <v-avatar size="128" color="primary" v-if="loading"
      ><v-progress-circular indeterminate></v-progress-circular
    ></v-avatar>
    <div style="width: 0; overflow: hidden; opacity: 0; height: 0">
      <v-file-input
        :rules="rules"
        accept="image/gif, image/png, image/jpeg"
        id="photo-file"
        label="File input"
        @change="sendAndSave"
      ></v-file-input>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProfilePhoto",
  data() {
    return {
      loading: false,
      rules: [
        (value) =>
          !value ||
          value.size < 5000000 ||
          "Avatar size should be less than 5 MB!",
      ],
    };
  },
  methods: {
    getBase64(file) {

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (res) => {
        const form = {
          logo: res.currentTarget.result,
          fileName: file.name,
          profileId: this.$root.auth.profileId
        }
        console.log('form', form)
        const url = `profiles/updatelogo/`;
        console.log('URL', url)
        const headers = this.$root.authToken
        this.$axios.post(url, form,{headers})
          .then((response) => {
            const user = JSON.parse(JSON.stringify(this.$root.auth))
          user.profile.logo = response.data.data.logo
          localStorage.setItem("auth", JSON.stringify(user));

            this.loading = false
          })
          .catch( (response) => {
            //handle error
            this.loading = false;
            console.log(response);
          });

      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    triggerFile() {
      const fileInput = document.getElementById("photo-file");
      fileInput.click();
    },
    sendAndSave() {
      this.loading = true;
      const fileInput = document.getElementById("photo-file");
      if (fileInput.files.length) {
        const file = fileInput.files[0];
        this.getBase64(file)
      } else {
        this.loading = false;
      }
    },
  },
};
</script>